<template lang="pug">
  .verification(v-if="data.step=='verification'")
    .verification__left
      .verification__title Ваш заказ
      .verification__left-list-wr(v-if="data.order")
        .verification__left-list
          .verification__left-list-head
            .verification__left-list-head-name Наименование:
            .verification__left-list-head-volume Вес/объем:
            .verification__left-list-head-count Количество:
            .verification__left-list-head-price Цена:
          .verification__left-list-item(v-for="item in data.order", :key="item.id")
            .verification__left-list-item-name(v-if="item.name") {{item.name}}
            .verification__left-list-item-volume(v-if="item.volume") {{item.volume}}
            .verification__left-list-item-volume(v-else) -
            .verification__left-list-item-count(v-if="item.count") {{item.count}}
            .verification__left-list-item-price(v-if="item.price") {{item.price.amount}} {{item.price.currency}}
    .verification__right
      .verification__title Адрес доставки
      .verification__right-delivery(v-if="data.delivery")
        .verification__right-delivery-row
          .verification__right-delivery-row-item(v-if="data.delivery.person")
            .verification__right-delivery-row-item-title Имя:
            .verification__right-delivery-row-item-text {{data.delivery.person}}
          .verification__right-delivery-row-item(v-if="data.delivery.phone")
            .verification__right-delivery-row-item-title Телефон:
            .verification__right-delivery-row-item-text {{data.delivery.phone}}
          .verification__right-delivery-row-item(v-if="data.delivery.count_persons")
            .verification__right-delivery-row-item-title Колличество персон:
            .verification__right-delivery-row-item-text {{data.delivery.count_persons}}
        .verification__right-delivery-row
          .verification__right-delivery-row-item(v-if="data.delivery.street")
            .verification__right-delivery-row-item-title Улица:
            .verification__right-delivery-row-item-text {{data.delivery.street}}
          .verification__right-delivery-row-item(v-if="data.delivery.home")
            .verification__right-delivery-row-item-title Дом:
            .verification__right-delivery-row-item-text {{data.delivery.home}}
          .verification__right-delivery-row-item(v-if="data.delivery.porch")
            .verification__right-delivery-row-item-title Подъезд:
            .verification__right-delivery-row-item-text {{data.delivery.porch}}
          .verification__right-delivery-row-item(v-else)
            .verification__right-delivery-row-item-title Подъезд:
            .verification__right-delivery-row-item-text -
          .verification__right-delivery-row-item(v-if="data.delivery.floor")
            .verification__right-delivery-row-item-title Этаж:
            .verification__right-delivery-row-item-text {{data.delivery.floor}}
          .verification__right-delivery-row-item(v-if="data.delivery.apartment")
            .verification__right-delivery-row-item-title Квартира:
            .verification__right-delivery-row-item-text {{data.delivery.apartment}}
        .verification__right-delivery-row
          .verification__right-delivery-row-item(v-if="data.delivery.comment")
            .verification__right-delivery-row-item-title Комментарии к заказу:
            .verification__right-delivery-row-item-text {{data.delivery.comment}}
      .verification__right-total(v-if="data.total_price")
        .verification__right-total-text Итого:
        .verification__right-total-price {{data.total_price.amount}} {{data.total_price.currency}}
      .verification__right-buttons
        router-link.verification__right-buttons-back(to="/korzina/oplata") Назад
        button.verification__right-buttons-next(@click="makeOrder") {{data.orderBtnTitle}}

</template>

<script>
import EventBus from '@/eventBus';

//import '@/components/verification/verification.styl';
import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';
import {ImagePreloaderVue} from '@/mixins/ImagePreloaderVue';
import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';

// @ is an alias to /src
//import Events from '@/components/events/Events.vue';

export default {
  name: 'Verification',

  mixins: [AjaxHelpersVue, ImagePreloaderVue],

  props: {
    data: {
      type: Object,
      required: true,
      default: null
    }
  },

  data() {
    return {

    }
  },

  components: {
    SvgIcon
    //Events
  },

  created() {

  },

  methods: {
    makeOrder() {
      let params = {
        cartId: this.getCartId()
      };

      this.checkout((res) => {
        if(this.checkProperty(this.checkProperty(res.status) && res.status === 'ok')) {
          if(res.paymentLink !== "") {
            window.open(res.paymentLink, '_blank');
          }
          this.cartStep('/korzina/vypolnenie');
        }
      }, params);
    }
  }
}
</script>
